var map = {
	"./blog/routes.js": "594c",
	"./management/routes.js": "9324",
	"./newsletters/routes.js": "43a9",
	"./notifications/routes.js": "8f4d",
	"./payment/routes.js": "761b",
	"./shop/routes.js": "8792"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60f4";